import React from "react";
import DesktopHeader from "@/components/layout/header/desktopHeader";
import MobileHeader from "@/components/layout/header/mobileHeader";
import { useParams } from "react-router-dom";
import { useGetInfoBranchForCategoriesPageQuery } from "@/graphql/categories/categories.hooks";
import { getMenuTypeFromUrl } from "@/components/cart/helpers/cartEvents";

interface IHeaderProps {
  onMobileSidebarOpen: () => void;
  onOpenSelected: () => void;
}

const Header: React.FC<IHeaderProps> = ({
  onMobileSidebarOpen,
  onOpenSelected,
}) => {
  const { menuId, branchId, typeMenu, locale } = useParams();
  const menuTypeEnum = getMenuTypeFromUrl(typeMenu);

  const hasMenuId = Boolean(menuId);

  const { data: infoBranchData, loading: infoBranchLoading } =
    useGetInfoBranchForCategoriesPageQuery({
      variables: {
        menuId: Number(menuId),
        branchId: Number(branchId),
        typeMenu: hasMenuId ? null : menuTypeEnum,
      },
      skip: !branchId || !menuTypeEnum || !locale,
    });
  const branchLogo = infoBranchData?.menu?.branch?.image;
  return (
    <>
      <DesktopHeader
        onOpenSelected={onOpenSelected}
        branchLogo={branchLogo}
        isLoading={infoBranchLoading}
      />
      <MobileHeader
        onOpenSidebar={onMobileSidebarOpen}
        branchLogo={branchLogo}
        isLoading={infoBranchLoading}
      />
    </>
  );
};

export default Header;
